import { Log } from './log';
import { ListProduct } from './product.interface.ts';

export interface DbLandingPage extends LandingPage {
    isActive: boolean;
    isForPreview: boolean;
    isOld: boolean;
    lastChangedInWoo: Date;
}

export interface LandingPage extends Log {
    id?: any;
    sections: Section[];
}

export interface Section {
    type: SectionType;
    title: string;
    subTitle: string;
    callToActionButtonText?: string;
    tag?: string;
    imageUrl?: string;
    categoryToNavigate?: string;
    numberOfArticles?: number;
    products?: ListProduct[];
    externalUrl?: string;
    category?: string;
    quote?: string;
}

export enum SectionType {
    /**
     * The first section on the page
     */
    Simple = 'simple',

    /**
     * The new in section
     */
    NewIn = 'newIn',

    /**
     * The sections that navigates to a collection
     */
    Collection = 'collection',

    /**
     * The sections that presents products
     */
    Products = 'products',

    /**
     * The section with external links
     */
    ExternalLink = 'externalLink',

    /**
     * The section with blog posts
     */
    Post = 'Post',

    /**
     * The section with texts, it only contains sa title and subtitle, it is used as header for other sections (e.g. Posts)
     */
    Text = 'text'
}
